import { Title, MSection, BoxDanger, MnemoLoading, BoxSuccess } from "components/misc";
import { ROUTES } from "const";
import { Icon } from "design-react-kit";
import { icdlService, learningService, networkErrorHelper } from "libs";
import React, { Component } from "react";
import { NavLink, withRouter } from 'react-router-dom';

class ICDLLesson extends Component {

    state = {
        loading: true,
        loadingError: false,
        isEnabled: 0,
        course: 0,
        rCode: ''
    };

    goBack() {
        window.history.back();
    }

    componentDidMount() {

        const { rCode } = this.props.match.params;
        this.loadRemote(rCode);
    }

    loadRemote(rCode) {

        learningService
            .courseDashboard(rCode)
            .then(({ data }) => {

                const { course, userCourse } = data.payload;
                this.setState({ course, userCourse });

                icdlService.getAICACodes(rCode)
                    .then(({ data }) => {
                        const codes = data.payload;

                        this.setState({ loading: false, loadingError: false, codes, rCode });
                    })
                    .catch(error => {
                        networkErrorHelper.notify(error);
                        this.setState({ loading: false, loadingError: true });
                    });

            })
            .catch(error => {

                if (!networkErrorHelper.is404(error)) {
                    networkErrorHelper.notify(error);
                }

                this.setState({ loading: false, loadingError: true });
            });
    }

    render() {

        const { rCode } = this.props.match.params;
        const { loading, codes, course } = this.state;

        if (loading) return (<MnemoLoading></MnemoLoading>);

        return (
            <>
                <NavLink to={`${ROUTES.COURSE_DASHBOARD}/${rCode}`} className="mx-5 btn btn-outline-primary float-right"><Icon icon="it-presentation" /> TORNA ALLA HOME PAGE DEL CORSO</NavLink>
                <Title >AICA Digital Academy</Title>
                <MSection>
                    <h6><a href="https://app.micertificoicdl.it/login" target="_blank" rel="noopener noreferrer"  >Clicca qui per accedere alla piattaforma AICA “micertificoicdl.it”</a></h6>
                    <footer className="blockquote-footer">https://app.micertificoicdl.it/login</footer>
                </MSection>
                <MSection className="mt-2">
                    <h1>Istruzioni Operative</h1>
                    <p>Dopo aver cliccato sul link di accesso AICA micertificoicdl.it visualizzerà la seguente schermata (Figura 1).</p>
                    <div className="image-container">
                        <img className="image-60 mb-1" src="/img/learning/aica/aica1.png" alt="Accesso piattaforma AICA" />
                        <footer className="blockquote-footer">Figura 1. Accesso piattaforma AICA</footer>
                    </div>
                    <p>Al primo accesso è richiesto di registrarsi facendo clic sul pulsante <b>Registrati</b> (Figura 1). </p>
                    <p>La Figura 2 mostra la procedura di registrazione con l’inserimento dei dati personali e di informazioni obbligatorie per l’attivazione dell’account:</p>
                    <div className="image-container">
                        <img className="image-60 mb-1" src="/img/learning/aica/aica2.png" alt="Procedura di registrazione" />
                        <footer className="blockquote-footer">Figura 2. Procedura di registrazione</footer>
                    </div>
                    <p>Una volta cliccato su Registrati riceverà un’e-mail di conferma registrazione con l’accesso al sistema (Figura 3).</p>
                    <div className="image-container">
                        <img className="image-60 mb-1" src="/img/learning/aica/aica3.png" alt="Contenuti disponibili per l’attivazione" />
                        <footer className="blockquote-footer">Figura 3. Contenuti disponibili per l’attivazione</footer>
                    </div>
                    {(course.code === 'ICDL238') ? (<>
                        <p>
                            Il codice di seguito riportato Le permetterà di attivare il modulo <b>IT SECURITY</b> e di approfondire i contenuti (vedi Figura 4):</p>
                        {(codes) && (
                            <BoxSuccess>Codice Attivazione IT Security: {codes[0]}</BoxSuccess>
                        )}
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/aica4.png" alt="Selezione ed attivazione del Corso IT Security" />
                            <footer className="blockquote-footer"> Figura 4. Selezione ed attivazione del Corso IT Security</footer>
                        </div>
                        <BoxDanger>Le ricordiamo che per attivare il modulo IT SECURITY occorre inserire il codice fornito nella casella <b>Riscatta questo corso</b> dopo aver cliccato sul riquadro relativo al modulo e di cliccare, infine, su Riscatta (Figura 5).
                            Dal momento dell’attivazione, avrà a disposizione i materiali didattici per i successivi 12 mesi.
                        </BoxDanger>
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/aica5it.png" alt="Inserimento codice di attivazione per il Corso IT Security" />
                            <footer className="blockquote-footer"> Figura 5. Inserimento codice di attivazione per il Corso IT Security</footer>
                        </div>
                        <p>Per qualsiasi informazione su tale procedura o su aspetti tecnici relativi all’utilizzo della piattaforma
                            telematica, potrà contattare il personale addetto a tale servizio dal Lunedì al Venerdì dalle ore 09:00 alle
                            ore 13:00 e dalle ore 14:30 alle ore 18:00 solo ed esclusivamente al seguente numero di telefono: 3664140604
                            o inviare e-mail a: <a href="mailto:supporto@formazionedocenti.it">supporto@formazionedocenti.it</a>.</p>
                        <hr />
                        <p><b>ATTENZIONE</b>: Nel caso di attivazione di moduli diversi da quello acquistato, si dovrà versare un contributo di Euro 100,00 per ogni nuovo codice di attivazione. Pertanto invitiamo a prestare la MASSIMA attenzione onde evitare spiacevoli ed onerosi errori.</p>
                    </>) : (<>
                        <p>
                            I 7 codici di seguito riportati Le permetteranno di attivare i 7 moduli del corso e di approfondire i contenuti (vedi Figura 4):                            </p>
                        {(codes) && (
                            <BoxSuccess>
                                <p>Codici attivazione moduli</p>
                                <ul>
                                    {codes.map(item => (
                                        <li>{item}</li>
                                    ))}
                                </ul>
                            </BoxSuccess>
                        )}
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/aica5full.png" alt="Attivazione Corso IT Security" />
                            <footer className="blockquote-footer"> Figura 4. Attivazione Moduli del Corso</footer>
                        </div>
                        <BoxDanger><b>ATTENZIONE</b><hr />
                            <p>Le ricordiamo che per attivare ciascun modulo ICDL, occorre inserire uno dei codici forniti nella casella <b>Riscatta questo corso</b> dopo aver cliccato sul riquadro relativo al modulo che si vuole attivare e di cliccare, infine, su Riscatta (Figura 4). L’utente è libero di associare ciascun codice ad uno qualsiasi dei sette moduli fino ad utilizzarli tutti. E’ chiaro che ciascun codice è utilizzabile una sola volta e per un solo modulo. Dal momento dell’attivazione, avrà a disposizione i materiali didattici per i successivi 12 mesi. Per questo motivo, consigliamo di attivare i moduli uno alla volta, man mano si procede con lo studio e la preparazione.</p>
                        </BoxDanger>
                        <p>In Figura 5, vengono mostrati i moduli che è possibile attivare ed i 7 moduli corrispondenti alla Certificazione Full Standard,
                            ovvero quelli da attivare:</p>
                        <div className="image-container">
                            <img className="image-60 mb-1" src="/img/learning/aica/aica6full.png" alt="Selezione ed attivazione dei singoli moduli del Corso ICDL Full Standard (7 moduli)" />
                            <footer className="blockquote-footer"> Figura 5. Selezione ed attivazione dei singoli moduli del Corso ICDL Full Standard (7 moduli)</footer>
                        </div>
                        <hr />
                        <p>Per qualsiasi informazione su tale procedura o su aspetti tecnici relativi all’utilizzo della piattaforma
                            telematica, potrà contattare il personale addetto a tale servizio dal Lunedì al Venerdì dalle ore 09:00 alle
                            ore 13:00 e dalle ore 14:30 alle ore 18:00 solo ed esclusivamente al seguente numero di telefono: 3664140604
                            o inviare e-mail a: <a href="mailto:supporto@formazionedocenti.it">supporto@formazionedocenti.it</a>.</p>
                        <hr />
                        <p><b>ATTENZIONE</b>: Nel caso di attivazione di moduli diversi da quello acquistato, si dovrà versare un contributo di Euro 100,00 per ogni nuovo codice di attivazione. Pertanto invitiamo a prestare la MASSIMA attenzione onde evitare spiacevoli ed onerosi errori.</p>
                    </>)}
                </MSection>
            </>);
    }
}

export default withRouter(ICDLLesson);